import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatCountAnalyseComponent } from './cat-count-analyse.component';
import {TpDropdownModule} from "../../../../components/tp-dropdown/tp-dropdown.module";
import {TranslateModule} from "@ngx-translate/core";
import { CatCountAnalyseModalComponent } from './cat-count-analyse-modal/cat-count-analyse-modal.component';
import { CatCountAnalyseAiModalComponent } from './cat-count-analyse-ai-modal/cat-count-analyse-ai-modal.component';
import {TpModalModule} from "../../../../components/tp-modal/tp-modal.module";
import {TpButtonModule} from "../../../../components/tp-button/tp-button.module";
import {TpTextBoxModule} from "../../../../components/tp-text-box/tp-text-box.module";
import {DragAndDropFileModule} from "../../../../components/drag-and-drop-file/drag-and-drop-file.module";
import {FileListModule} from "../../../sharedComponents/file-list/file-list.module";
import {ReactiveFormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
    declarations: [
        CatCountAnalyseComponent,
        CatCountAnalyseModalComponent,
        CatCountAnalyseAiModalComponent
    ],
    exports: [
        CatCountAnalyseModalComponent,
        CatCountAnalyseAiModalComponent
    ],
    imports: [
        CommonModule,
        TpDropdownModule,
        TranslateModule,
        TpModalModule,
        TpButtonModule,
        TpTextBoxModule,
        DragAndDropFileModule,
        FileListModule,
        ReactiveFormsModule,
        MatIconModule
    ]
})
export class CatCountAnalyseModule { }